import Button from "Components/Common/Button/Button";
import type { SidebarSection } from "../types/reports.types";

interface ReportsSidebarProps {
  sections: SidebarSection[];
  activeSection: string;
  onSelect: (id: string) => void;
}

export default function ReportsSidebar({
  sections,
  activeSection,
  onSelect,
}: ReportsSidebarProps) {
  const groupedSections = sections.reduce<Record<string, SidebarSection[]>>(
    (acc, section) => {
      const key = section.navGroup ?? "General";
      if (!acc[key]) acc[key] = [];
      acc[key].push(section);
      return acc;
    },
    {},
  );

  return (
    <aside className="reportsSidebar">
      {Object.entries(groupedSections).map(([group, items]) => (
        <div key={group} className="reportsSidebarGroup">
          <p className="reportsSidebarHeading">{group}</p>
          {items.map((item) => (
            <Button
              key={item.id}
              type="button"
              className={`reportsSidebarItem${activeSection === item.id ? " active" : ""}`}
              onClick={() => onSelect(item.id)}
            >
              {item.navIcon && item.navIcon}
              {item.navLabel}
            </Button>
          ))}
        </div>
      ))}
    </aside>
  );
}
